import React, { useState, useEffect, useRef } from 'react';
import Layout from '../../components/Layout/Layout'
import axios from 'axios'
import { Link } from 'react-router-dom';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { SERVER_API } from '../../fileWithConstants';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/auth';
import { FaCheck } from 'react-icons/fa';
const ItemFabricListing = () => {
  const saveTimers = useRef({});
  const [auth, setAuth] = useAuth();
  const [fabrics, setFabrics] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(0);

const [remarks, setRemarks] = useState({});
const [saving, setSaving] = useState({});
const [saved, setSaved] = useState({});

const handleRemarkChange = (fabricId, value) => {
    // Update textarea immediately
    setRemarks(prev => ({
        ...prev,
        [fabricId]: value
    }));

    // Clear previous timer
    if (saveTimers.current[fabricId]) {
        clearTimeout(saveTimers.current[fabricId]);
    }

    // Save after 1 second of no typing
    saveTimers.current[fabricId] = setTimeout(() => {
        saveRemark(fabricId, value);
    }, 1000);
};

const saveRemark = async (fabricId, remark) => {
    try {
        setSaving(prev => ({
            ...prev,
            [fabricId]: true
        }));

        const { data } = await axios.post(
            `${SERVER_API}/api/v1/fabric/save-remark`,
            {
                fabric_id: fabricId,
                remark: remark ?? ''
            },
            {
                headers: {
                    Authorization: auth?.token
                }
            }
        );

        if (data?.success) {
            setSaved(prev => ({
                ...prev,
                [fabricId]: true
            }));

            setTimeout(() => {
                setSaved(prev => ({
                    ...prev,
                    [fabricId]: false
                }));
            }, 2000);
        }
    } catch (error) {
        console.log(error);
    } finally {
        setSaving(prev => ({
            ...prev,
            [fabricId]: false
        }));
    }
};

const Loader = () => (
  <div className="text-center my-4">
    <Spinner animation="border" role="status" variant="primary">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);

    const getAllItems = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-all-items`);
      if(data?.success){
        const all_items = data?.items;
        setItems(all_items);
      }
    } catch (error) {
      console.log(error)
    }
  }

useEffect(()=>{
   getAllItems();
},[]);

const handleItemChange = async(selectedOptions)=>{
    try {
      if(selectedOptions.length>0){
          const st_item  = selectedOptions?.[0]['i_id'];
          setFabrics([]);
          setLoading(true);
          setSelectedItem(st_item);
            const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabricdata-for-item/${st_item}`);
            //console.log(data)
            if(data?.success && data?.fabrics.length>0){
              const fb_main_arr = data?.fabrics;
              setFabrics(fb_main_arr);
              setLoading(false);
            }else{
              setFabrics([]);
              setLoading(false);
            }
        
      }
    } catch (error) {
      setLoading(false);
      console.log(error)
    }
}

  return (
    <Layout title={'Item List'}>
        <div className='container'>
            <h1 className='page-title'>Item List</h1>
              <div className="row justify-content-center">
                <div className="custom-inline-form">
                  <div className='col-md-12 form-box big-box item-big-box'>
                            <Typeahead
                                  name="supplier_id"
                                  id="basic-typeahead-single"
                                  labelKey="i_name"
                                  onChange={handleItemChange}
                                  options={items}
                                  placeholder="Select Item"
                              />
                  </div>
                  <div className='col-md-4  form-box btn-box'> 
                  <Link className="btn btn-primary" onClick={()=>{ window.location.reload(); }}>Reset</Link>
                  </div>
                  </div>
              </div>
            
            <div className='col-md-12 m-t5'>
  <div className='table-box item-fabric-table'>
    {loading ? (
      <Loader />
    ) : (
      <table className="table table-responsive table-hover table-sticky">
        <thead>
          <tr>
            <th scope="col" className='text-start'>Fabric Name</th>
            <th scope="col">Primary</th>
            <th scope="col" style={{width:"60px"}}>Photo</th>
            <th scope="col">Category</th>
            <th scope="col">BOM QTY</th>
            <th scope="col">QTY in stock</th>
            <th scope="col">Remark</th>
          </tr>
        </thead>
        <tbody>
          {fabrics && fabrics.length > 0 ? (
  Object.entries(
    fabrics.reduce((slugGroups, fb) => {
      if (!slugGroups[fb.fabric_slug]) slugGroups[fb.fabric_slug] = {};
      if (!slugGroups[fb.fabric_slug][fb.e_name || "No Embroidery"])
        slugGroups[fb.fabric_slug][fb.e_name || "No Embroidery"] = [];
      slugGroups[fb.fabric_slug][fb.e_name || "No Embroidery"].push(fb);
      return slugGroups;
    }, {})
  ).map(([slug, eNameGroups]) => (
    <React.Fragment key={slug}>
      {/* Header for fabric_slug */}
      <tr className="table-secondary">
        <td colSpan="7" className="text-center">
          {slug}
        </td>
      </tr>

      {Object.entries(eNameGroups).map(([eName, group]) => (
        <React.Fragment key={eName}>
          {/* Sub-header for e_name */}
          {eName !== "No Embroidery" && (
            <tr className="table-light">
            <td colSpan="7" className="text-start">
              {eName}
            </td>
          </tr>
          )}
          

          {/* Fabric rows under this e_name */}
          {group.map((fb) => (
            <tr key={fb.id}>
              <td className="text-start">
                <Link to={`/dashboard/item-listing-for-fabric/${fb.fb_id}`} target='_blank'>
                  {fb.name}
                </Link>
              </td>
              <td className="text-center">
                {fb.primary_fb === 1 ? (
                  <FaCheck className='text-success'/>
                ):''}
                </td>
              <td className='img-box'>
                {fb.fabric_photo ? (
                  <Link
                    to={`${SERVER_API}/uploads/fabrics/${fb.fabric_photo}`}
                    target="_blank"                    
                  >
                    <img
                      src={`${SERVER_API}/uploads/fabrics/${fb.fabric_photo}`}
                      alt={fb.name}
                    />
                  </Link>
                ) : (
                  ""
                )}
              </td>
              <td>{fb.category_name}</td>             
              <td>{fb.quantity?.toLocaleString("en-US")}</td>
              <td>{(fb.total_in - fb.total_out)?.toLocaleString("en-US")}</td>
               <td style={{ minWidth: "220px" }}>
                 <textarea
                        className={`form-control ${
                            saved[fb.fb_id] ? 'remark-saved' : ''
                        }`}
                        rows={2}
                        value={remarks[fb.fb_id] ?? fb.remark ?? ''}
                        placeholder="Enter remark"
                        onChange={(e) =>
                            handleRemarkChange(
                                fb.fb_id,
                                e.target.value
                            )
                        }
                    />

                  {saving[fb.fb_id] && (
                      <small className="text-primary">
                          Saving...
                      </small>
                  )}
              </td>
            </tr>
          ))}
        </React.Fragment>
      ))}
    </React.Fragment>
  ))
) : (
  <tr>
    <td colSpan="11" className="text-center text-muted">
      No fabrics found.
    </td>
  </tr>
)}

        </tbody>
      </table>
    )}
  </div>
</div>
</div>

    </Layout>
  )
}

export default ItemFabricListing